<div class="match-form-container" [loading]="loading()">
	<fieldset>
		<p class="title-xs font-serra mb-1">Autres cartes similaires</p>
		<p class="opacity-60 mb-4">Sélectionne la bonne carte parmi les résultats ci-dessous</p>

		<!-- topk -->
		<div [ngClass]="{hidden: action()!='match'}">
			<div class="topk-container mb-2">
			  	@for(top of topK(); track top){
			  		@if(top.card.ident!=topSelected().card.ident){
				  		<a flyTo="selectedSlot" (click)="topSelected.set(top)" class="topk card-body">
						  	<img hSkeleton="200px" class="img-card-topk shadow-sm" [altImg]="cardS.getImages(top.card.img)"/>
						</a>
					}
				}
			</div>

			<div class="search-btn">
				<button (click)="searchCard()" class="text-xs btn text-primary">
					<i class="fa-solid fa-magnifying-glass"></i> Rechercher une carte
				</button>
			</div>
		</div>

		<!-- search card -->
		<div [ngClass]="{hidden: action()=='match'}" class="search-container" [loading]="searching()">
			<!-- close -->
			<a (click)="action.set('match')" class="text-primary">
				<i class="fa-solid fa-arrow-left"></i> Retour
			</a>
			<label class="input input-md input-bordered input-lg w-full gap-2 mb-2">
			  <input 
			  	#textSearch
			  	#searchable="searchable"
			  	[autoload]="false"
			  	[(ngModel)]="qSearch"
			  	[qSearch]="qSearch()"
			  	[search]="getSearchObs()" 
			  	[(results)]="results"
			  	[(searching)]="searching"
			  	[length]="9"
			  	name="search"
			  	type="text"
			  	class="opacity-60" 
			  	placeholder="Recherchez une carte..."
			  />
			  <span class="opacity-60"><i class="fa-light fa-magnifying-glass"></i></span>
			</label>
			<div class="search-result mb-4">
				@if(results().length){
					<div class="search-list">
						@for(card of results(); track card.ident){
					  		<a flyTo="selectedSlot" (click)="selectResult(card)" class="topk card-body ">
							  	<img hSkeleton="200px" class="img-card-topk shadow-sm" [altImg]="cardS.getImages(card.img)"/>
							</a>
						}
					</div>
					<div class="pagination mt-4">
						<div class="join">
						  @if(searchable.canPrev()){
					  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
					  	  }
						  <button class="join-item btn">Page {{searchable.page()+1}}</button>
						  @if(searchable.canNext()){
						  	<button (click)="searchable.next()" class="join-item btn">»</button>
						  }
						</div>
					</div>
				}
				@else{
					<p class="opacity-60">Aucun résultat ? Essaie avec le nom anglais.</p>
				}
			</div>
		</div>
	</fieldset>
</div>

<div class="btn-container mt-4">
	<button (click)="update.emit(true)" class="btn btn-primary btn-gradient">
		Modifier
	</button>
</div>